type ReferenceDocIdLike = {
  doc_id?: string | null;
  pmid?: string | null;
  openalex_id?: string | null;
  search_gateway?: string | null;
  link?: string | null;
};

function normalizeOpenAlexId(value: string) {
  return value.trim().replace(/^https?:\/\/openalex\.org\//i, '');
}

export function getReferenceDocId(reference: ReferenceDocIdLike) {
  const explicitDocId = reference.doc_id?.trim();
  if (explicitDocId) {
    if (
      !explicitDocId.includes('|') &&
      (reference.search_gateway?.trim().toLowerCase() === 'openalex' ||
        reference.openalex_id?.trim() ||
        reference.link?.match(/openalex\.org\/([^/?#]+)/i))
    ) {
      return `openalex|${normalizeOpenAlexId(explicitDocId)}`;
    }
    return explicitDocId;
  }

  const explicitOpenAlexId = reference.openalex_id?.trim();
  if (explicitOpenAlexId) {
    return `openalex|${normalizeOpenAlexId(explicitOpenAlexId)}`;
  }

  const openAlexLinkMatch = reference.link?.match(/openalex\.org\/([^/?#]+)/i);
  if (openAlexLinkMatch?.[1]) {
    return `openalex|${normalizeOpenAlexId(openAlexLinkMatch[1])}`;
  }

  const pmid = reference.pmid?.trim();
  return pmid ? `pubmed|${pmid}` : '';
}
